var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPhone = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 15,
  viewBox: "0 0 15 15",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M9.872 10.8c-.502.5-1.159.049-2.415-.968A19 19 0 0 1 4.83 7.21c-.581-.725-1.097-1.482-.566-2.016.05-.05 1.236-1.23 1.234-1.232.286-.285.296-.678.08-.892 0 0-2.928-2.924-2.928-2.922-.227-.228-.623-.188-.893.08L.518 1.464c-.54.678-1.748 3.915 3.433 9.218 5.439 5.562 8.954 4.393 9.577 3.767.007.007 1.243-1.23 1.244-1.228.284-.29.295-.683.076-.9 0 0-2.843-2.84-2.843-2.838-.227-.228-.624-.187-.896.082z"
})));
export default SvgPhone;